import { Modal } from "@mui/material";
import React, { useState } from "react";
import { Close } from "@mui/icons-material";
import Styles from "./CreateCharge.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import { ErrorMessage } from "../../../../commons/Toast/ErrorMessage";
import {
  createNewCharge,
  updateCharge,
  updateNewCharge,
} from "../../../../Services/Payments/PaymentApi";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";

const chargeType = [
  { id: 1, label: "Platform", value: "Platform" },
  { id: 2, label: "Trader", value: "Trader" },
  { id: 3, label: "STU", value: "State/STU" },
  { id: 4, label: "ISTS", value: "ISTS" },
];

const CreateCharge = ({ open, handleClose, handleUpdate, editData }) => {
  console.debug("edit", editData);
  const [chargeName, setChargeName] = useState(
    editData?.data ? editData?.data?.name : ""
  );
  const [type, setType] = useState(
    editData?.data
      ? chargeType?.filter((ele) => ele?.value === editData?.data?.type)?.[0]
      : {
          id: 1,
          label: "Platform",
          value: "Platform",
        }
  );
  const [isEditable, setIsEditable] = useState(
    editData?.data?.isEditable || true
  );

  const handleChargeName = (e) => {
    setChargeName(e);
  };

  const handleSubmit = async () => {
    if (chargeName.trim() === "") {
      ErrorMessage("Charge name cannot be empty");
      return;
    }

    if (editData?.data) {
      handleEdit();
    }

    let payload = {
      name: chargeName,
      value: 0,
      frequency: "ONE_TIME",
      type: type?.value,
      isEditable: isEditable,
      isUserCharge: true,
      platform: "OTC",
    };
    let res = await createNewCharge(payload);
    if (res?.data?.code === 200) {
      handleUpdate();
      handleClose();
    } else {
      ErrorMessage("Failed to create charge");
      return;
    }
  };

  const handleEdit = async () => {
    let payload = {
      id: editData?.data?.id,
      name: chargeName,
      value: 0,
      frequency: "ONE_TIME",
      type: type?.value,
      isEditable: isEditable,
      isUserCharge: true,
      platform: "OTC",
    };
    let res = await updateNewCharge(payload);
    if (res?.data?.code === 200) {
      handleUpdate();
      handleClose();
    } else {
      ErrorMessage("Failed to create charge");
      return;
    }
  };

  const handleType = (data) => {
    setType(data);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.chargesCreateContainer}`}>
        <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
          <div className={`headingText`}>
            {editData?.data ? "Edit" : "Create"} Charge
          </div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.modalCOntainer}>
          <TextInput
            heading={`Enter New Charge Name*`}
            value={chargeName}
            onChange={(value) => handleChargeName(value)}
            example={"ABC Charge"}
            type={"text"}
            height="45"
          />
          <SelectInput
            onChange={handleType}
            list={chargeType}
            value={type}
            example={"Select Charge Type"}
            heading={"Charge Type"}
            height={"45px"}
          />
          <div className={Styles.chargeSelection}>
            <div className={Styles.chargeSelectionHeading}>
              Is Charge Editable by User?
            </div>
            <div className={Styles.editableSelection}>
              <div
                onClick={() => setIsEditable(false)}
                className={!isEditable && Styles.isEditable}
              >
                No
              </div>
              <div
                onClick={() => setIsEditable(true)}
                className={isEditable && Styles.isEditable}
              >
                Yes
              </div>
            </div>
          </div>
          <div
            onClick={handleSubmit}
            className={`activeButton ${Styles.buttonElem1}`}
          >
            Submit
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreateCharge;
